/**
 * A drop's SMS texts on the Day timeline (user, 22/10/2026: "add Gateway
 * Senders Texts info so you can see the full picture"): the draft's first
 * text and how many more, the first six numbered behind the tooltip (two
 * lines each, so it stays on screen) and how many beyond them; muted
 * "at generation" before the day is laid out, "not written yet" while the
 * draft waits for its texts.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Tooltip } from '@/components/ui';

import type { DayPlanDropRow } from '../../../drop-generator.types';

/** Texts the tooltip lists — more would run off the screen. */
const SHOWN = 6;

const Muted: FC<{ text: string; tip: string }> = ({ text, tip }) => (
  <Tooltip content={tip}>
    <span className="block truncate text-xs text-muted-foreground">{text}</span>
  </Tooltip>
);

export const TextsCell: FC<{ drop: DayPlanDropRow }> = ({ drop }) => {
  const texts = drop.runtime?.texts ?? null;
  if (!drop.runtime?.hasDraft) return <Muted text="at generation" tip="The texts are written when the day is generated." />;
  if (!texts || texts.length === 0) return <Muted text="not written yet" tip="The draft is waiting for its texts." />;
  const tip = (
    <span className="flex flex-col gap-1">
      <ol className="flex list-decimal flex-col gap-1 pl-4">
        {texts.slice(0, SHOWN).map((t, i) => (
          <li key={i}>
            <span className="line-clamp-2">{t}</span>
          </li>
        ))}
      </ol>
      {texts.length > SHOWN ? <span className="opacity-70">+{texts.length - SHOWN} more — every text is on the draft (Open today’s drafts)</span> : null}
    </span>
  );
  return (
    <Tooltip content={tip} contentClassName="max-w-md">
      <span className="flex min-w-0 items-center gap-1 text-xs" data-testid="drop-texts">
        <span className="truncate">{texts[0]}</span>
        {texts.length > 1 ? <span className="shrink-0 font-mono text-muted-foreground">+{texts.length - 1}</span> : null}
      </span>
    </Tooltip>
  );
};
